import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';
import { Icon, InlineIcon } from '@iconify/react';
import chevronDown from '@iconify/icons-mdi/chevron-down';
import chevronRight from '@iconify/icons-mdi/chevron-right';

const TabContainer = Styled.div`
`;

const Tab = Styled.div`
  align-items: center;
  background-color: ${Theme.blue};
  border: 0;
  cursor: pointer;
  display: flex;
  padding: 2px 3px 2px 19px;

  &.disabled {
    background-color: rgba(${Theme.yellowRGB}, 0.25);
    cursor: default;
  }

  p {
    color: ${Theme.white};
    font-family: ${Theme.fontFamily};
    font-size: 14px;
    line-height: 17px;
    margin: 0;
  }

  .neko-side-tab-icon {
    color: ${Theme.white};
    margin-left: auto;
    height: 36px;
    width: 36px;
  }
`;

const TabContent = Styled.div`
  background-color: ${Theme.white};
  display: none;

  &.active {
    display: block;
  }
`;

/**
 * Need to use with NecoTab
 */
const StyledNekoSideTabs = props => {

  const [activeTabIndex, setIsActiveTabIndex] = React.useState();

  const tabAttributes = React.Children.map(props.children, (child, i) => {
    const title = child.props.title || ("Untitled Tab " + (i + 1));
    const key = child.props.key || 'neko-tab-' + title.toLowerCase();
    const onClick = child.props.onClick ? child.props.onClick : null;
    const requirePro = !props.isPro && (child.props.requirePro || false);
    return { key, title, onClick, requirePro };
  });

  const children = React.Children.map(props.children, (child, i) => {
    return React.cloneElement(child, {
      isActive: i === activeTabIndex
    });
  });

  const onTabClick = (tabIndex, tabAttr, ev) => {
    if (tabAttr.requirePro) return;
    const newTabIndex = tabIndex === activeTabIndex ? null : tabIndex;
    setIsActiveTabIndex(newTabIndex);
    if (props.onChange) {
      props.onChange(newTabIndex, tabAttr, ev);
    }
  };

  return (
    <TabContainer>
      {tabAttributes.map((attr, i) =>
        <React.Fragment>
          <Tab
            key={attr.key}
            className={`${i === activeTabIndex ? 'active' : ''} ${attr.requirePro ? 'disabled' : ''}`}
            onClick={(ev) => { onTabClick(i, attr, ev); }}
          >
            <p>
              {attr.title}
              <ProOnly className="inline" show={attr.requirePro} />
            </p>
            <Icon icon={i === activeTabIndex ? chevronDown : chevronRight } className="neko-side-tab-icon" />
          </Tab>
          { children[i] }
        </React.Fragment>
      )}
    </TabContainer>
  );
};


/**
 * @oaram {string} title
 * @param {bool} isActive
 */
const StyledNekoSideTab = props => {

  const { children, isActive } = props;

  return (
    <TabContent className={`${isActive ? 'active' : ''}`}>
      { children }
    </TabContent>
  );
};

const NekoSideTabs = (props) => {
  return (<StyledNekoSideTabs {...props} />);
};

NekoSideTabs.propTypes = {
  isPro: PropTypes.bool,
  onChange: PropTypes.func
};

NekoSideTabs.defaultProps = {
  isPro: false,
  onChange: undefined
};

const NekoSideTab = (props) => {
  return (<StyledNekoSideTab {...props} />);
};

NekoSideTab.propTypes = {
  isActive: PropTypes.bool,
  requirePro: PropTypes.bool,
  title: PropTypes.string
};

NekoSideTab.defaultProps = {
  isActive: false,
  requirePro: false,
  title: undefined
};

export { NekoSideTab, NekoSideTabs };
